module.exports = __webpack_public_path__ + "static/media/13.11294170.svg";